$(document).ready(() => {
    new Swiper(".last-matches-command", {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: '.last-matches-command .swiper-button-next',
            prevEl: '.last-matches-command .swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            // when window width is >= 320px
            1400: {
                slidesPerView: 3,
            },
            1000: {
                slidesPerView: 2,
            },
        }
    });

    let tournamentType = TOURNAMENT_TYPE;
    // const $body = $('body');
    // if (tournamentType === '3') {
    //     $body.addClass("bg-3x3");
    // }
    const $playerStatsBlock = $('.playerStats');

    $('#playerTournamentType input').on('change', function (event) {
        const value = '' + $(this).val();

        $playerStatsBlock.each(function() {
            const $block = $(this);

            if ($block.data('tournament-type') !== +value) {
                $block.hide();
            } else {
                $block.show();
            }
        });

        if (value !== tournamentType) {
            tournamentType = value;
            // if (tournamentType === '3') {
            //     $body.addClass("bg-3x3");
            // } else {
            //     $body.removeClass("bg-3x3");
            // }
        }
    });

});
